import { ASSETS } from "@/lib/assets";
import { Reveal } from "@/components/site/Reveal";

export const LoopReel = () => (
  <section className="relative py-12 md:py-20">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <Reveal>
        <div className="relative rounded-2xl overflow-hidden border border-white/10">
          <video
            data-testid="loop-reel-video"
            className="w-full aspect-video object-cover bg-black"
            src={ASSETS.loopVideo}
            poster={ASSETS.loopPoster}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-background/20" />
          <div className="absolute bottom-6 left-6 md:bottom-9 md:left-10 max-w-lg">
            <p className="overline mb-3">The closed loop</p>
            <h3 className="font-serif font-light text-3xl md:text-5xl leading-[1.02] tracking-[-0.02em]">
              Diagnose. Personalize.<br />Deliver. Repeat.
            </h3>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
